export default "__VITE_ASSET__C2P7iJkC__"